import { render, staticRenderFns } from "./manageHospital.vue?vue&type=template&id=663d3b80&scoped=true&"
import script from "./manageHospital.vue?vue&type=script&lang=js&"
export * from "./manageHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d3b80",
  null
  
)

export default component.exports